import React from 'react';
import AnchorNav from '../../components/anchor-nav';
import Breadcrumb from '../../platformui/Breadcrumb';
import CommentForm from '../../platformui/CommentForm';
import BusinessHours from '../../platformui/Contact-card/business-hours';
import ContactAlert from '../../platformui/Contact-card/contact-alert';
import ContactCardPanel from '../../platformui/Contact-card/contact-card-panel';
import ContactHeader from '../../platformui/Contact-card/contact-header';
import CurrentInfo from '../../platformui/Contact-card/current-info';
import EServices from '../../platformui/Contact-card/e-services';
import FindCareHow from '../../platformui/Contact-card/find-care-how';
import FindUs from '../../platformui/Contact-card/find-us';
import InfoVisitor from '../../platformui/Contact-card/info-visitor';
import ListingInformation from '../../platformui/Contact-card/listing-information';
import PatientInformation from '../../platformui/Contact-card/patient-information';
import PhoneHours from '../../platformui/Contact-card/phone-hours';
import PracticalInformation from '../../platformui/Contact-card/practical-information';
import ReadMore from '../../platformui/Contact-card/read-more';
import RelatedUnits from '../../platformui/Contact-card/related-units';
import Unit from '../../platformui/Contact-card/unit';
import UnitQualityIndicators from '../../platformui/Contact-card/unit-quality-indicators';
import WaitingTimes from '../../platformui/Contact-card/waiting-times';
import YourVisit from '../../platformui/Contact-card/your-visit';
import withIntersectionObserver from '../../platformui/Containers/withIntersectionObserver';
import Section from '../../platformui/Section';
import Share from '../../platformui/Share';
import MatomoTrackAppUserDimension from '../../platformui/Matomo/matomo-track-app-user-dimension';

import {
  showAboutUs,
  showBusinessHours,
  showFindCareHow,
  showFindUs,
  showInfoVisitor,
  showListing,
  showPatientInformation,
  showPracticalInformation,
  showUnitQualityIndicators,
  showYourVisit,
} from '../../platformui/Contact-card/helpers';

const ObservedAnchorNav = withIntersectionObserver(AnchorNav);

const ContactCardPage = (props) => {
  let cardConfig = getCardConfig(props);
  const localNavItems = [];
  if (props && props.Content) addItemsToLocalNav(props.Content);

  function addItemsToLocalNav(Content) {
    const { Card, Translations } = Content;

    if (!Card) return null;

    if (Card.EServices && Card.EServices.length > 0) {
      localNavItems.push({
        Name: Translations.eservice,
        Id: 'eservice',
      });
    }

    if (Card.WaitingTimes) {
      localNavItems.push({
        Name: Translations.waitingtimes,
        Id: 'waitingtimes',
      });
    }
    if (Card.Phone) {
      localNavItems.push({
        Name: Translations.phone,
        Id: 'phonehours',
      });
    }

    if (showBusinessHours(Card.BusinessHours)) {
      localNavItems.push({
        Name: Translations.openinghours,
        Id: 'bussinesshours',
      });
    }

    if (showFindUs(Card)) {
      localNavItems.push({
        Name: Translations.findus,
        Id: 'contact',
      });
    }

    if (Card.CurrentInfo?.Items?.length > 0) {
      localNavItems.push({
        Name: Translations.news,
        Id: 'news',
      });
    }

    if (showAboutUs(Card.AboutUs))
      localNavItems.push({
        Name: Translations.aboutus,
        Id: 'aboutus',
      });

    if (showFindCareHow(Card.FindCareHow))
      localNavItems.push({
        Name: Translations.findcarehow,
        Id: 'findcarehow',
      });

    if (showPatientInformation(Card.PatientInformation))
      localNavItems.push({
        Name: Translations.infopatients,
        Id: 'patientinformation',
      });

    if (showYourVisit(Card.YourVisit))
      localNavItems.push({
        Name: Translations.yourvisit,
        Id: 'yourvisit',
      });

    if (
      showInfoVisitor({
        VisitingHours: Card?.VisitorInformation?.VisitingHours,
        Descriptions: Card?.VisitorInformation?.Descriptions,
        Ingress: Card?.VisitorInformation?.Ingress,
      })
    )
      localNavItems.push({
        Name: Translations.infovisitor,
        Id: 'infovisitor',
      });

    if (showPracticalInformation(Card.PracticalInformation)) {
      localNavItems.push({
        Name: Translations.practicalinformation,
        Id: 'practical-information',
      });
    }

    if (Card.Related) {
      localNavItems.push({
        Name: Translations.relatedunits,
        Id: 'related-units',
      });
    }

    if (showListing(Card.UnitListingRelation)) {
      localNavItems.push({
        Name: Translations.listyourself,
        Id: 'listing-information',
      });
    }

    if (showUnitQualityIndicators(Card.UnitQualityIndicator)) {
      localNavItems.push({
        Name: Translations.unitqualityindicators,
        Id: 'quality-indicators',
      });
    }

    if (Card.ReadMoreLinks) {
      localNavItems.push({
        Name: Translations.readmorehjv,
        Id: 'readmore',
      });
    }
  }

  function getCardConfig(props) {
    const {
      apiConfig,
      Content: {
        Card,
        Translations,
        WaitingTimesDescription,
        ShowDropinCompact,
      },
    } = props;

    return [
      {
        showCard: Card.EServices.length > 0,
        key: 'EServices',
        Component: () => <EServices Translations={Translations} {...Card} />,
        panelProps: {
          contactCardHeading: Translations.eservice,
          id: 'eservice',
          open: true,
        },
      },
      {
        showCard: Card.WaitingTimes,
        key: 'WaitingTimes',
        Component: () => (
          <WaitingTimes
            Translations={Translations}
            {...Card.WaitingTimes}
            WaitingTimesDescription={WaitingTimesDescription}
          />
        ),
        panelProps: {
          contactCardHeading: Translations.waitingtimes,
          id: 'waitingtimes',
          open: true,
        },
      },
      {
        showCard: Card.Phone,
        key: 'phonehours',
        Component: () => <PhoneHours Translations={Translations} {...Card} />,
        panelProps: {
          contactCardHeading: Translations.phone,
          id: 'phonehours',
          open: true,
        },
      },
      {
        showCard: showBusinessHours(Card.BusinessHours),
        key: 'bussinesshours',
        Component: () => (
          <BusinessHours
            Translations={Translations}
            ShowDropinCompact={ShowDropinCompact}
            {...Card}
          />
        ),
        panelProps: {
          contactCardHeading: Translations.openinghours,
          id: 'bussinesshours',
          open: true,
        },
      },
      {
        showCard: showFindUs(Card),
        key: 'Address',
        Component: () => (
          <FindUs
            Translations={Translations}
            {...Card}
            apiKey={apiConfig.googleMapsClientApiKey}
            addressGrid={
              Card.StaticMapUrl
                ? 'columns large-6 large-pull-6'
                : 'columns large-6'
            }
          />
        ),
        panelProps: {
          contactCardHeading: Translations.findus,
          id: 'contact',
          open: true,
        },
      },
      {
        showCard: Boolean(Card.CurrentInfo?.Items?.length > 0),
        key: 'CurrentInfo',
        Component: () => (
          <CurrentInfo
            Translations={Translations}
            Items={Card.CurrentInfo?.Items}
          />
        ),
        panelProps: {
          contactCardHeading: `${Translations.news}`,
          id: 'news',
          open: true,
        },
      },
      {
        showCard: showAboutUs(Card.AboutUs),
        key: 'AboutUs',
        Component: () => <Unit {...Card.AboutUs} Translations={Translations} />,
        panelProps: {
          contactCardHeading: Translations.aboutus,
          id: 'aboutus',
          open: true,
        },
      },
      {
        showCard: showFindCareHow(Card.FindCareHow),
        key: 'FindCareHow',
        Component: () => (
          <FindCareHow {...Card.FindCareHow} Translations={Translations} />
        ),
        panelProps: {
          contactCardHeading: Translations.findcarehow,
          id: 'findcarehow',
          open: false,
        },
      },
      {
        showCard: showPatientInformation(Card.PatientInformation),
        key: 'PatientInformation',
        Component: () => (
          <PatientInformation
            PatientInformation={Card.PatientInformation}
            Translations={Translations}
          />
        ),
        panelProps: {
          contactCardHeading: Translations.infopatients,
          id: 'patientinformation',
          open: false,
        },
      },
      {
        showCard: showYourVisit(Card.YourVisit),
        key: 'YourVisit',
        Component: () => (
          <YourVisit Translations={Translations} YourVisit={Card.YourVisit} />
        ),
        panelProps: {
          contactCardHeading: Translations.yourvisit,
          id: 'yourvisit',
          open: false,
        },
      },
      {
        showCard: showInfoVisitor({
          ...Card.AboutUs,
          VisitingHours: Card?.VisitorInformation?.VisitingHours,
          Descriptions: Card?.VisitorInformation?.Descriptions,
          Ingress: Card?.VisitorInformation?.Ingress,
        }),
        key: 'InfoVisitor',
        Component: () => (
          <InfoVisitor
            {...Card.AboutUs}
            Translations={Translations}
            VisitingHours={Card?.VisitorInformation?.VisitingHours}
            Descriptions={Card?.VisitorInformation?.Descriptions}
            Ingress={Card?.VisitorInformation?.Ingress}
          />
        ),
        panelProps: {
          contactCardHeading: Translations.infovisitor,
          id: 'infovisitor',
          open: false,
        },
      },
      {
        showCard: showPracticalInformation(Card.PracticalInformation),
        key: 'PracticalInformation',
        Component: () => (
          <PracticalInformation
            {...Card.PracticalInformation}
            Translations={Translations}
          />
        ),
        panelProps: {
          contactCardHeading: Translations.practicalinformation,
          id: 'practical-information',
          open: false,
        },
      },
      {
        showCard: Boolean(Card.Related),
        key: 'RelatedUnits',
        Component: () => (
          <RelatedUnits {...Card.Related} Translations={Translations} />
        ),
        panelProps: {
          contactCardHeading: Translations.relatedunits,
          id: 'related-units',
          open: false,
          Modifiers: {
            'hide-for-print':
              Card.Related === undefined ||
              Card.Related.RelatedUnits.length === 0,
          },
        },
      },
      {
        showCard: showListing(Card.UnitListingRelation),
        key: 'Listing',
        Component: () => <ListingInformation {...Card.UnitListingRelation} />,
        panelProps: {
          contactCardHeading: Translations.listyourself,
          id: 'listing-information',
          open: false,
        },
      },
      {
        showCard: showUnitQualityIndicators(Card.UnitQualityIndicator),
        key: 'UnitQualityIndicators',
        Component: () => (
          <UnitQualityIndicators
            {...Card.UnitQualityIndicator}
            Translations={Translations}
          />
        ),
        panelProps: {
          contactCardHeading: Translations.unitqualityindicators,
          id: 'quality-indicators',
          open: true,
        },
      },
      {
        showCard: Boolean(Card.ReadMoreLinks),
        key: 'ReadMoreLinks',
        Component: () => <ReadMore ReadMoreLinks={Card.ReadMoreLinks} />,
        panelProps: {
          contactCardHeading: Translations.readmorehjv,
          id: 'readmore',
          open: true,
        },
      },
    ];
  }

  const { Card, Translations } = props.Content;

  const panelProps = {
    currentActiveId: null,
  };

  return (
    <>
      <div className="row">
        <div className="columns">
          <Breadcrumb {...props.Breadcrumbs} Language={props.Language} />
        </div>
      </div>

      <main className="main">
        <div className="row">
          <div className="small-12 columns">
            <Section
              Modifiers={{
                'c-section--first': true,
                'c-section--intro': true,
              }}
            >
              <ContactHeader {...Card} Translations={Translations} />
              <ContactAlert {...Card} />
            </Section>
          </div>
        </div>
        <div id="content" className="row">
          <div className="contact-card-page">
            <div className="large-9 columns">
              {cardConfig.map((Item) => {
                if (!Item.showCard) return null;
                return (
                  <ContactCardPanel
                    {...panelProps}
                    {...Item.panelProps}
                    key={Item.key}
                  >
                    <Item.Component Translations={Translations} />
                  </ContactCardPanel>
                );
              })}

              <CommentForm
                FeedbackForm={Card.FeedbackForm}
                HsaId={Card.HsaId}
                PageUrl={props.PageUrl}
                Modifiers={{
                  'contact-card-comment--last': true,
                }}
              />

              <Share {...props.Content} />
            </div>

            <div className="large-3 columns">
              <div className="u-100-height">
                <ObservedAnchorNav
                  items={localNavItems}
                  anchorHeading={Translations.anchorheading}
                  Links={localNavItems}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
      <MatomoTrackAppUserDimension />
    </>
  );
};

export default ContactCardPage;
